<template>
  <div class="input-group">
    <DatePicker :key="localValue" ref="datepicker" v-model="localValue" :bootstrap-styling="true" :calendar-button="true"
                :clear-button="clear && !disabled && !readonly" :disabled="disabled" :disabled-dates="disabledDates" :format="customFormatter"
                :language="translations" :open-date="openDate" :parser="customParser" :placeholder="placeholder" :append-to-body="true"
                :readonly="readonly" :typeable="typeable" input-class="form-control">
      <template #calendarBtn>
        <fa icon="calendar"></fa>
      </template>
      <template #clearBtn>
        <fa icon="times"/>
      </template>
    </DatePicker>
  </div>
</template>

<script>
import DatePicker from '@sum.cumo/vue-datepicker'
import { format, parse } from 'date-fns'
import store from '~/store'
import Language from '@sum.cumo/vue-datepicker/dist/locale/Language.esm'
import moment from 'moment/moment'

export default {
  name: 'o-datepicker-control',
  props: {
    value: {
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    typeable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    disabledDates: {
      type: Object
    },
    openDate: {
      type: Date
    },
    placeholder: {
      type: String,
      default: 'Select Date'
    },
    clear: {
      type: Boolean,
      default: true
    },
    initialTime: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    localValue: '',
    language: {}
  }),

  mounted () {
    this.localValue = this.value
  },

  computed: {
    translations () {
      return new Language(
        this.$i18n.t('core.language_name'), [
          this.$i18n.t('core.january_long'),
          this.$i18n.t('core.february_long'),
          this.$i18n.t('core.march_long'),
          this.$i18n.t('core.april_long'),
          this.$i18n.t('core.may_long'),
          this.$i18n.t('core.june_long'),
          this.$i18n.t('core.july_long'),
          this.$i18n.t('core.august_long'),
          this.$i18n.t('core.september_long'),
          this.$i18n.t('core.october_long'),
          this.$i18n.t('core.november_long'),
          this.$i18n.t('core.december_long')
        ], [
          this.$i18n.t('core.january_short'),
          this.$i18n.t('core.february_short'),
          this.$i18n.t('core.march_short'),
          this.$i18n.t('core.april_short'),
          this.$i18n.t('core.may_short'),
          this.$i18n.t('core.june_short'),
          this.$i18n.t('core.july_short'),
          this.$i18n.t('core.august_short'),
          this.$i18n.t('core.september_short'),
          this.$i18n.t('core.october_short'),
          this.$i18n.t('core.november_short'),
          this.$i18n.t('core.december_short')
        ], [
          this.$i18n.t('core.sunday_short'),
          this.$i18n.t('core.monday_short'),
          this.$i18n.t('core.tuesday_short'),
          this.$i18n.t('core.wednesday_short'),
          this.$i18n.t('core.thursday_short'),
          this.$i18n.t('core.friday_short'),
          this.$i18n.t('core.saturday_short')
        ])
    }
  },

  methods: {
    customFormatter (date) {
      if (date) {
        const user = store.getters['auth/user']
        if (user) {
          let userFormat = user.format_date
          userFormat = userFormat.replace(/DD/g, 'dd').replace(/YYYY/g, 'yyyy')
          return format(new Date(date), userFormat)
        } else {
          return format(new Date(date), 'dd.MM.yyyy')
        }
      }
      return null
    },
    customParser (date) {
      if (date) {
        const user = store.getters['auth/user']
        if (user) {
          let userFormat = user.format_date
          userFormat = userFormat.replace(/DD/g, 'dd').replace(/YYYY/g, 'yyyy')
          return parse(date, userFormat, new Date())
        } else {
          return parse(date, 'dd.MM.yyyy', new Date())
        }
      }
      return null
    }
  },

  components: {
    DatePicker
  },

  watch: {
    value (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal === null) {
          this.localValue = ''
        } else {
          this.localValue = newVal
        }
      }
    },
    localValue (newVal, oldVal) {
      if (newVal !== oldVal) {
        newVal = typeof newVal === 'string' ? newVal.replace(/T/g, ' ').replace(/\+00:00/g, ''): newVal
        const date = moment(newVal).utc()
        this.$emit('input', newVal && date.isValid() ? (this.initialTime ? format(new Date(date), 'yyyy-MM-dd HH:mm:ss') : format(new Date(date), 'yyyy-MM-dd 00:00:00')) : null)
        this.$emit('input-changed', newVal && date.isValid() ? (this.initialTime ? format(new Date(date), 'yyyy-MM-dd HH:mm:ss') : format(new Date(date), 'yyyy-MM-dd 00:00:00')) : null)
      }
    }
  }
}
</script>

<style lang="scss">
@import '~@sum.cumo/vue-datepicker/src/styles/style.scss';

.vdp-datepicker__calendar-button {
  span, {
    height: calc(1.5em + 0.75rem + 2px)
  }
}

.vdp-datepicker__clear-button {
  span {
    height: calc(1.5em + 0.75rem + 2px)
  }
}

.vdp-datepicker__calendar {
  z-index: 2147483647 !important;
}
</style>
